import type { ComponentProps } from 'react'
import type { ExtraProps } from 'react-markdown'

interface TableProps extends ComponentProps<'table'>, ExtraProps {}

/** Scrolls sideways inside its own box, so a wide table never widens the page. */
function Table({ node: _node, className, children, ...props }: TableProps) {
  return (
    <div className="md-table">
      <table className={className} {...props}>
        {children}
      </table>
    </div>
  )
}

Table.displayName = 'Markdown.Table'

export { Table }
export type { TableProps }
